/** @module SiteAdmin/Lookup/CopySpecificationItemItem */
define([
	"dojo/_base/declare",
	"csi",
	"csi/reflection",
	"csi/table/Copy"
], function(declare,csi,reflection,Copy) {

	return declare(Copy, {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: fix type based on switchboard
			var node = this.getNode();
			view.addFixedValue("Subtype", node.Subtype);

			this.inherited(arguments);
		}
	});
});